import React from "react";

import s from "./SelectableCard.module.scss";

const SelectableCard = ({ content, selected, handleSelect }) => {
  return (
    <div
      className={`${s.cardLayout} ${selected && s.selected}`}
      onClick={handleSelect}
    >
      {content}
    </div>
  );
};

export default SelectableCard;
